import { compose } from 'redux';
import { connect } from 'react-redux';
import SettingCustom from '../../../pages/Admin/SettingCustom/SettingCustom';
import withAuth from '../../../common/WithAuth';
import * as Actions from '../../../actions/AdminSettingCustom';

const mapStateToProps = (state) => ({
    isLoading: state.adminSettingCustom.getCustomColor.isFetching
        || state.adminSettingCustom.updateCustomColor.isFetching
        || state.adminSettingCustom.getCustomText.isFetching
        || state.adminSettingCustom.updateCustomText.isFetching
        || state.adminSettingCustom.updateCustomTimerctrl.isFetching,

    customColor: state.adminSettingCustom.getCustomColor.data,
    updateCustomColor: state.adminSettingCustom.updateCustomColor.data,
    customText: state.adminSettingCustom.getCustomText.data,
    updateCustomText: state.adminSettingCustom.updateCustomText.data,
    customComment: state.adminSettingCustom.getCustomComment.data,
    updateCustomComment: state.adminSettingCustom.updateCustomComment.data,
    updateStatusComment: state.adminSettingCustom.updateCustomComment.updateStatus,
    
    customTimerctrl      :state.adminSettingCustom.getCustomTimerctrl.data,
    updateCustomTimerctrl:state.adminSettingCustom.updateCustomTimerctrl.data,
    updateStatusTimerctrl:state.adminSettingCustom.updateCustomTimerctrl.updateStatus,    
    
    eventInfo: state.eventManagement.infoEvent.data,
});

const mapDispatchToProps = (dispatch) => ({
    getSettingCustomColor: (params) => {
        dispatch(Actions.getSettingCustomColorRequested(params));
    },
    clearGetSettingColor: () => {
        dispatch(Actions.getSettingCustomColorClear());
    },
    updateSettingCustomColor: (params) => {
        dispatch(Actions.updateSettingCustomColorRequested(params));
    },
    clearUpdateSettingColor: () => {
        dispatch(Actions.updateSettingCustomColorClear());
    },
    getSettingCustomText: (params) => {
        dispatch(Actions.getSettingCustomTextRequested(params));
    },
    clearGetSettingCustomText: () => {
        dispatch(Actions.getSettingCustomTextClear());
    },
    updateSettingCustomText: (params) => {
        dispatch(Actions.updateSettingCustomTextRequested(params));
    },
    clearUpdateSettingCustomText: () => {
        dispatch(Actions.updateSettingCustomTextClear());
    },
    getSettingCustomComment: (params) => {
        dispatch(Actions.getSettingCustomCommentRequest(params));
    },
    clearGetSettingCustomComment: () => {
        dispatch(Actions.getSettingCustomCommentClear());
    },
    updateSettingCustomComment: (params) => {
        dispatch(Actions.updateSettingCustomCommentRequest(params));
    },
    clearUpdateSettingCustomComment: () => {
        dispatch(Actions.updateSettingCustomCommentClear());
    },
    getSettingCustomTimerctrl: (params) => {
        dispatch(Actions.getSettingCustomTimerctrlRequest(params));
    },
    clearGetSettingCustomTimerctrl: () => {
        dispatch(Actions.getSettingCustomTimerctrlClear());
    },
    updateSettingCustomTimerctrl: (params) => {
        dispatch(Actions.updateSettingCustomTimerctrlRequest(params));
    },
    clearUpdateSettingCustomTimerctrl: () => {
        dispatch(Actions.updateSettingCustomTimerctrlClear());
    },


});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SettingCustom);
